import HomeHeader from "../Component/HomeComponent/HomeHeader";

import ShowCaseCardRow from "../Component/HomeComponent/ShowCaseCardRow";
import { projectsData } from "./StaticData/HomeProjectData";
import { useState, useEffect } from "react";
import { PageContainer } from "../Component/HomeComponent/GeneralComponents";
import {
  SubPageTitle,
  SectionContainer,
} from "../Component/HomeComponent/GeneralComponents";

export default function ProjectsPage() {
  const [ismobile, setIsMobile] = useState(0);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <PageContainer>
      <HomeHeader />
      <SectionContainer id="project">
        <SubPageTitle
          ismobile={ismobile}
          style={{
            paddingBottom: 0,
            marginLeft: 0,
            paddingTop: " 8vh",
          }}
        >
          Projects
        </SubPageTitle>

        <ShowCaseCardRow>{projectsData}</ShowCaseCardRow>
      </SectionContainer>
    </PageContainer>
  );
}
